<div class="headings">
  <h4 class="content-heading">
    {{ 'pages.user-cards.create.steps.information.heading' | translate }}
  </h4>
</div>

<article *ngIf="instructionsStepsInfo" class="article-mb quill-content-wrapper ql-editor" 
  [innerHTML]="instructionsStepsInfo | safeHtml">
</article>

<form [formGroup]="form">
  <div class="user-bcitiCard">

    <div class="user-infos">
      <div class="avatar-block">
        <img class="user-avatar" [src]="picture" alt="demo-avatar">
        
        <div class="user-name-wrap">
          <span class="user-name">{{ firstName }} {{ lastName }}</span>
        </div>

      </div>
      <div class="infos-block">
        <p><span class="label">{{ 'pages.user-cards.create.steps.information.sex' | translate }}:</span> {{ 'pages.user-cards.create.steps.confirmation.' + sex | translate }}</p>
        <p><span class="label">{{ 'pages.user-cards.create.steps.information.birthdate' | translate }}:</span> {{ birthDate }}</p>
      </div>
    </div>
    <app-form-geoid-address
      label="{{ 'pages.profile.mainAddress' | translate }}"
      searchType="default" 
      formControlName="address">
    </app-form-geoid-address>
    <div class="form">
      <app-user-card-select 
        *ngIf="subTypes.length > 0"
        [options]="subTypes"
        controlName="subType"
        [form]="form"
        placeholder="{{ 'pages.user-cards.create.steps.information.subTypes.label' | translate }}"
        label="{{ 'pages.user-cards.create.steps.information.subTypes.label' | translate }}">
      </app-user-card-select>
    </div>
    <div class="form">
      <app-form-input
        *ngIf="cardActions != CardActions.RENEW" 
        label="{{ 'pages.user-cards.family.common.fields.citizenCardNumber.placeholder' | translate }}"
        placeholder="{{ 'pages.user-cards.family.common.fields.citizenCardNumber.placeholder' | translate }}"
        formControlName="cardNumber"
        [messages]="true"
      ></app-form-input>
    </div>
    <div class="form">
      <app-form-datepicker
        class="text-input" 
        label="{{ 'pages.user-cards.update.expDate' | translate }}" 
        formControlName="expDate" 
        [min]="tomorrow" 
        data-cy="expDate"
      >
        <app-form-error *ngIf="expDate.touched && expDate.hasError('required')">
            {{ 'pages.user-cards.update.errors.expDateRequired' | translate }}
        </app-form-error>
      </app-form-datepicker>   
    </div> 
  </div>
</form>